/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Project }                    from './project';
import { ProjectType }                from "@/models/project.type";
import { ProjectElement }             from './project/project.element';
import { SimulationElement }          from './project/simulation.element';
import { LocomotiveModelElement }     from '@/models/project/locomotive.model.element';
import { OperationalMeasuresElement } from '@/models/project/operational.measures.element';
import { ProjectFactoryDecorator }    from "@/models/project.factory.decorator";

/**
 *
 * @class SimulationProject
 *
 * @brief this project is for a single scenario simulation, one input, one output.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
@ProjectFactoryDecorator('SimulationProject')
export class SimulationProject extends Project {

  /** standard constructor */
  constructor(name: string) {

    super(name, 'fas fa-cube');

    this.type = ProjectType.Simulation;
    this.icon = '<i class="fas fa-cube"></i>';
    this.facon = 'fas fa-cube';

    /* build up default structure */

    const a:    ProjectElement = new SimulationElement(this, '', this.root());
    const b:    ProjectElement = new LocomotiveModelElement(this, '', this.root());
    const c:    ProjectElement = new OperationalMeasuresElement(this, '', this.root());

  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring SimulationProject");
  }

}
